import { IServices } from "@netent/origin";
import { View } from "@netent/playui";
import { Store } from "redux";
import { actions, IStoreAction, IStoreState } from "../../store";
import { PlayUIListenerCreator } from "../../types";

export const onViewChangeRequest: PlayUIListenerCreator = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>
) => (view: View) => {
  const currentView = store.getState().view;

  switch (currentView) {
    case View.MAIN_SETTINGS:
      services.gameSettings.close();
      break;
    case View.GAME_RULES:
      services.gameRules.setState("closed");
      break;
    case View.PAYTABLE:
      services.paytable.close();
      break;
    case View.AUTOPLAY_SETTINGS:
      if (!services.autoplay.isActive()) {
        services.autoplay.stop();
      }
      services.autoplay.setSettingsState("closed");
      break;
    default:
      break;
  }

  switch (view) {
    case View.MAIN_SETTINGS:
      services.gameSettings.open();
      break;
    case View.GAME_RULES:
      services.gameRules.setState("opened");
      break;
    case View.PAYTABLE:
      services.paytable.open(); // TODO: Rename to notifyOpen or something. It does not open the paytable.
      break;
    case View.AUTOPLAY_SETTINGS:
      services.autoplay.setSettingsState("opened");
      break;
    default:
      break;
  }

  if (view === View.DEFAULT && currentView !== view) {
    services.gameSettings.setViewState(view);
  } else if (currentView !== view) {
    services.gameSettings.setViewState("");
  }

  store.dispatch(actions.updateView(view));
};
